<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-block`]" width="1em" height="1em" v-bind="$attrs"><rect x="3.23" y="4.178" width="9.152" height="6.572" rx="2" stroke="#165DFF" stroke-width="1.66"/><rect x="20.768" y="19.822" width="9.152" height="6.572" rx="2" transform="rotate(-180 20.768 19.822)" stroke="#165DFF" stroke-width="1.66"/><rect x="3.23" y="13.25" width="5.787" height="6.572" rx="2" stroke="#165DFF" stroke-width="1.66"/><rect x="20.768" y="10.75" width="5.787" height="6.572" rx="2" transform="rotate(-180 20.768 10.75)" stroke="#00BBD8" stroke-width="1.66"/></svg>
</template>
<script>

export default {
  name: 'IconColorBlock',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
